import clsx from "clsx";
import {
    Divider,
    Drawer,
    IconButton,
    List,
    Typography,
} from "@material-ui/core";
import React from "react";
import { ReactComponent as LrmIcon } from "icons/LrmIcon.svg";
import { ReactComponent as ThorIcon } from "icons/ThorIcon.svg";
import { ReactComponent as FormIcon } from "icons/FormIcon.svg";
import { ReactComponent as FlowIcon } from "icons/FlowIcon.svg";
import { ReactComponent as PlanningIcon } from "icons/PlanningIcon.svg";
import { ReactComponent as UsersIcon } from "icons/Users.svg";
import { ReactComponent as LeftArrow } from "icons/NavLeftArrow.svg";
import { ReactComponent as RightArrow } from "icons/NavRightArrow.svg";
import { NavbarItem } from "./NavbarItem";
import { navbarStyles } from "./NavbarStyles";
import { observer } from "mobx-react";
import { useStore } from "store/StoreConfigs";
export default observer(function Navbar() {
    const classes = navbarStyles();
    const { commonStore } = useStore();

    const Icons = [
        { icon: LrmIcon, text: "Lane Risk Assessment", route: "/lrm" },
        { icon: PlanningIcon, text: "Lane Planning & Forecast", route: "" },
        { icon: ThorIcon, text: "Excursion Impact Evaluation", route: "/thor" },
        { icon: FormIcon, text: "Form Creation", route: "" },
        { icon: FlowIcon, text: "Distribution Flow Creation", route: "" },
        { icon: UsersIcon, text: "User Management", route: "/users" },
    ];
    const handleNavbarClose = () => {
        commonStore.setNavbarOpen();
    };

    return (
        <div className={classes.root}>
            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: commonStore.isNavbarOpen,
                    [classes.drawerClose]: !commonStore.isNavbarOpen,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: commonStore.isNavbarOpen,
                        [classes.drawerClose]: !commonStore.isNavbarOpen,
                    }),
                }}
            >
                <div>
                    <img
                        src="/images/SmallLogo.png"
                        className={classes.image}
                        alt="Carrier"
                    />
                    {commonStore.isNavbarOpen && (
                        <Typography className={classes.logo}>
                            CARRIER LYNX
                            <br />
                            MANAGEMENT SYSTEM
                        </Typography>
                    )}
                </div>
                <Divider />
                <List>
                    {Icons.map((Icon, index) => (
                        <div key={index}>
                            <NavbarItem
                                route={Icon.route}
                                navbarIcon={<Icon.icon />}
                                navbarIconStyles={classes.icons}
                                selectedState={
                                    commonStore.selectedTab === index
                                }
                                navbarItemStyles={clsx({
                                    [classes.selected]:
                                        commonStore.selectedTab === index,
                                    [classes.Unselected]: !(
                                        commonStore.selectedTab === index
                                    ),
                                })}
                                navbarTextStyles={clsx(classes.text, {
                                    [classes.selectedText]:
                                        commonStore.selectedTab === index,
                                    [classes.Unselected]: !(
                                        commonStore.selectedTab === index
                                    ),
                                })}
                                navbarText={Icon.text}
                                onClickFunc={() =>
                                    commonStore.setSelectedTab(index)
                                }
                            />
                            {index === 1 && (
                                <Divider
                                    style={{
                                        marginBottom: "10px",
                                        marginTop: "10px",
                                    }}
                                />
                            )}
                        </div>
                    ))}
                </List>
                <div className={classes.grow}></div>

                {commonStore.isNavbarOpen ? (
                    <IconButton
                        className={clsx({
                            [classes.expandButton]: true,
                            [classes.expandButtonOpened]:
                                commonStore.isNavbarOpen,
                        })}
                        onClick={commonStore.setNavbarClose}
                    >
                        <div className={classes.navLeftArrow}>
                            <LeftArrow />
                        </div>
                    </IconButton>
                ) : (
                    <IconButton
                        className={clsx({
                            [classes.expandButton]: true,
                            [classes.expandButtonOpened]:
                                commonStore.isNavbarOpen,
                        })}
                        onClick={handleNavbarClose}
                    >
                        <div className={classes.navRightArrow}>
                            <RightArrow />
                        </div>
                    </IconButton>
                )}
            </Drawer>
        </div>
    );
});
